<template>
  <div class="no-product-available row q-col-gutter-md">
    <!-- <div class="col">
      <h2 class="text-h5 q-mt-auto"></h2>
    </div> -->
    <div class="col">
      <h2 class="text-h5 q-mt-auto">{{ title }}</h2></div
    >
  </div>
  <div class="npa-section">
    <div
      class="column items-center q-pa-xl flex flex-center rounded"
      style="height: 370px; margin-top: 26px"
    >
      <!-- Circle logo -->
      <div
        class="flex flex-center"
        style="
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: #e0e0e0;
        "
      >
        <q-icon name="inventory_2" size="64px" color="grey-7" />
      </div>

      <!-- Title -->
      <div class="text-h5 text-center q-mt-lg"> No Products Available </div>

      <!-- Subtitle -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>
